<template>
  <div class="align-center d-flex header">
    <h1 class="header-title">
      {{ title }}
      <slot name="title" />
    </h1>

    <slot name="actions"></slot>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
  },
};
</script>

<style>
.header-title {
  font-weight: 500;
}
</style>
